import {
    StyleSheet
} from "react-native";

export const NAVIGATION_MENU_LINK_LABEL_VARIANT: keyof NCoreUIKit.Typography = "labelMediumSize";

const stylesheet = StyleSheet.create({
    item: {
        alignSelf: "stretch"
    },
    label: {
        minWidth: 0,
        flex: 1
    }
});
export default stylesheet;
